import { FaCheckSquare } from "react-icons/fa";
import { FaCircle } from "react-icons/fa";
import Table from "../../../../components/table/table";

const JobInformationTab = ({ t, id }) => {
  const assets = [
    {
      type: "مفتاح خزنة ",
      status: (
        <span className="flex flex-row-reverse items-center justify-center gap-2">
          بحوزته <FaCircle className="text-[#11A849]" />
        </span>
      ),
    },
    {
      type: "لاب توب",
      status: (
        <span className="flex flex-row-reverse items-center justify-center gap-2">
          مفقود <FaCircle className="text-[#D1A855]" />
        </span>
      ),
    },
    {
      type: "جهاز بصمة",
      status: (
        <span className="flex flex-row-reverse items-center justify-center gap-2">
          تم تسليمها <FaCircle className="text-[#5566D1]" />
        </span>
      ),
    },
  ];

  const tableHead = [
    {
      header: t("assetType"),
      accessorKey: "type",
    },
    {
      header: t("status"),
      accessorKey: "status",
    },
  ];
  return (
    <div className="bg-[#182443] p-8 rounded-lg space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-bold">{t("employeeInfo")}</h3>
        <span className="bg-[#FFFFFF33] grid place-content-center size-6 rounded-[4px]">
          x
        </span>
      </div>
      <div>
        <h3 className="text-primary">{t("mainInfo")}</h3>
        <section className="p-4 space-y-2 border border-primary rounded-xl">
          <div className="flex flex-wrap items-center md:flex-nowrap">
            <div className="w-full">
              <p className="font-bold text-primary">{t("fullName")}:</p>
              <p className="mt-1 text-xl font-semibold">{id}</p>
            </div>
            <div className="w-full">
              <p className="font-bold text-primary">{t("email")}:</p>
              <p className="mt-1 text-xl font-semibold">mohamed@club.com</p>
            </div>
          </div>
          <div className="flex flex-wrap items-center md:flex-nowrap">
            <div className="w-full">
              <p className="font-bold text-primary">{t("job")}:</p>
              <p className="mt-1 text-xl font-semibold">مدرب فتنس</p>
            </div>
            <div className="w-full">
              <p className="font-bold text-primary">{t("department")}:</p>
              <p className="mt-1 text-xl font-semibold">الأنشطة الرياضية</p>
            </div>
          </div>
          <div className="flex flex-wrap items-center md:flex-nowrap">
            <div className="w-full">
              <p className="font-bold text-primary">{t("status")}:</p>
              <p className="flex items-center gap-2 mt-1 text-xl font-semibold">
                <FaCheckSquare className="text-[#11A849]" />
                نشط
              </p>
            </div>
            <div className="w-full">
              <p className="font-bold text-primary">{t("employmentDate")}:</p>
              <p className="mt-1 text-xl font-semibold">01/01/2022</p>
            </div>
          </div>
        </section>
      </div>
      <section className="grid p-4 space-y-4 border border-primary rounded-xl">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-bold">{t("jopAssets")}</h3>
          <span className=" size-[16px]">x</span>
        </div>
        <div className="p-2 border rounded-lg border-primary w-fit">
          <span className="font-medium text-mainGray">{t("job")} :</span>
          <span className="font-semibold">مدرب لياقة</span>
        </div>
        <Table TableData={assets} TableHead={tableHead} tableStyle="!min-w-[400px]" />
      </section>
    </div>
  );
};

export default JobInformationTab;
